  
 
 import { Component } from '@angular/core';
 import { HttpClient } from '@angular/common/http';
 import {
   NotificationScheduleService
 } from '../../services/notification-schedule.service';
 import { Column } from '../../interfaces/column.interface';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { Router } from '@angular/router';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';  
 @Component({
   selector: 'app-notification-list',
   templateUrl: './notification-list.component.html'
 })
 export class NotificationListComponent {
 
   loading = false;
   successMessage = '';
   errorMessage = '';
   notifications: any = [];
   public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '100'};
   public selectedNotifications: any = [];

   public columns: Column[] = [];
    public isLoading: boolean = false;
    public isInitialized: boolean = false;
    public locale: string = (localStorage.language) ? localStorage.language : 'en';
    private _selectedColumns: Column[] = [];
 
 
   constructor(private http: HttpClient, private notificationScheduleService :NotificationScheduleService,
        private navigation: NavigationService,
            private router: Router,
            private messageService: MessageService,
            private primengConfig: PrimeNGConfig,


   ) {}
 
  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications() {
    this.loading = true;
 
        if (parseInt(this.parameters.offset + '', 10) === 0) {
          this.loading = true;
        }
       this.notificationScheduleService.getList(this.parameters).subscribe((response: any) => {
        this.loading = false;

        if (response !== null) {
          // let newNotifications = response.success.data.map((notif: any) => {
          //   // Parse startTime et endTime
          //   const startDate = new Date(notif.startTime?.date + ' UTC'); // UTC pour éviter décalage
          //   const endDate = new Date(notif.endTime?.date + ' UTC');

          //   // Options de formatage
          //   const options: Intl.DateTimeFormatOptions = {
          //     hour: '2-digit',
          //     minute: '2-digit',
          //     timeZone: 'Africa/Abidjan'
          //   };
          // const isValidDate = (d: Date) => d instanceof Date && !isNaN(d.getTime());

          //   return {
          //     ...notif,
          //     startFormatted: isValidDate(startDate)
          //       ? startDate.toLocaleTimeString('fr-FR', options)
          //       : '-',
          //     endFormatted: isValidDate(endDate)
          //       ? endDate.toLocaleTimeString('fr-FR', options)
          //       : '-',
          //   };
          // });
          let newNotifications = response.success.data.map((notif: any) => {
            const startDate = new Date(notif.startTime?.date + ' UTC');
            const endDate = new Date(notif.endTime?.date + ' UTC');

            const options: Intl.DateTimeFormatOptions = {
              hour: '2-digit',
              minute: '2-digit',
              timeZone: 'Africa/Abidjan'
            };

            const isValidDate = (d: Date) => d instanceof Date && !isNaN(d.getTime());

            const isSendingNow = this.isNotificationSendingNow(notif);

            return {
              ...notif,
              startFormatted: isValidDate(startDate)
                ? startDate.toLocaleTimeString('fr-FR', options)
                : '-',
              endFormatted: isValidDate(endDate)
                ? endDate.toLocaleTimeString('fr-FR', options)
                : '-',

              // ✅ NOUVEAU STATUS
              sendStatusLabel: isSendingNow ? 'Envoi en cours' : 'Pas de notif en cours',
              sendStatusClass: isSendingNow ? 'sending' : 'not-sending'
            };
          });
          if (parseInt(this.parameters.offset + '', 10) === 0) {
            this.notifications = newNotifications;
          } else {
            this.notifications = this.notifications.concat(newNotifications);
          }

          console.log(this.notifications); // Vérifier que startFormatted et endFormatted sont là

          // Pagination
          if (response.inlineCount > this.notifications.length) {
            this.parameters.offset = (parseInt(this.parameters.offset + '', 10) + parseInt(this.parameters.limit + '', 10)) + '';
            this.loadNotifications();
          } else {
            this.parameters.offset = '0';
          }
        }
      }, (error: any) => {
        this.loading = false;
      });

 
        
  }
 

 
  goToScheduler(): void {
    this.router.navigate(['/notifications/send']);
  }
  
    // ✅ ICI LA FONCTION
  isNotificationSendingNow(notif: any): boolean {
    if (!notif.isActive) {
      return false;
    }

    const now = new Date();
    const today = now
      .toLocaleDateString('en-US', { weekday: 'long' })
      .toLowerCase();

    if (!notif.daysOfWeek || !notif.daysOfWeek.includes(today)) {
      return false;
    }

    if (notif.isUnlimitedTime) {
      return true;
    }

    if (!notif.startTime || !notif.endTime) {
      return false;
    }

    const start = new Date(notif.startTime.date + ' UTC');
    const end = new Date(notif.endTime.date + ' UTC');

    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = start.getUTCHours() * 60 + start.getUTCMinutes();
    const endMinutes = end.getUTCHours() * 60 + end.getUTCMinutes();

    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  }
  
  isNotificationActiveNow(notif: any): boolean {
    if (!notif.isActive) {
      return false;
    }

    const now = new Date();

    // Jour actuel (monday, tuesday, ...)
    const today = now.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

    // Vérifier le jour
    if (!notif.daysOfWeek || !notif.daysOfWeek.includes(today)) {
      return false;
    }

    // Si temps illimité → actif
    if (notif.isUnlimitedTime) {
      return true;
    }

    // Si pas de start/end → inactif
    if (!notif.startTime || !notif.endTime) {
      return false;
    }

    // Comparaison des heures
    const start = new Date(notif.startTime.date + ' UTC');
    const end = new Date(notif.endTime.date + ' UTC');

    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = start.getUTCHours() * 60 + start.getUTCMinutes();
    const endMinutes = end.getUTCHours() * 60 + end.getUTCMinutes();

    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  }


  deleteNotification(id: number) {
    if (confirm('Voulez-vous vraiment supprimer cette notification ?')) {
      this.notificationScheduleService.deleteNotification(id).subscribe({
        next: () => {
          this.notifications = this.notifications.filter((n:any) => n.id !== id);
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Notification supprimée'
          });
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Suppression échouée'
          });
        }
      });
    }
  }

 }
 